import { createI18n } from "vue-i18n";

// Define locales.
const messages = {
    tr: {
        // Backness translations
        front:      'Ön',
        central:    'Orta',
        back:       'Arka',

        // Height translations
        close:          'Kapalı',
        'near-close':   'near-close',
        'close-mid':    'Yarı-Kapalı',
        mid:            'Orta',
        'open-mid':     'Yarı-açık',
        'near-open':    'near-open',
        open:           'Açık',

        // Roundedness translations
        unrounded:  'Düz',
        rounded:    'Yuvarlak',

        // Consonant place translations
        bilabial:       'Çiftdudak',
        labiodental:    'Dudakdiş',
        alveolar:       'Dişyuvasıl',
        postalveolar:   'Dişardı',
        palatal:        'Damaksıl',
        velar:          'Artdamaksıl',
        glottal:        'Gırtlaksıl',

        // Consonant manner translations
        plosive:        'Patlamalı',
        nasal:          'Genizsil',
        'tap-or-flap':  'Çarpmalı',
        fricative:      'Sürtünücü',
        affricate:      'Afrike',
        approximant:    'Daralmalı',
        'lateral-approximant': 'Yandaralmalı',

        // Phonetic consonant variant translations
        consonant: {
            place: {
                bilabial:     'Çiftdudak',
                labiodental:  'Dudakdiş',
                alveolar:     'Dişyuvasıl',
                postalveolar: 'Artdişyuvasıl',
                palatal:      'Öndamaksıl',
                velar:        'Artdamaksıl',
                glottal:      'Gırtlaksıl',
            },
            manner: {
                plosive:        'Patlamalı',
                nasal:          'Genizsil',
                'tap-or-flap':  'Çarpmalı',
                fricative:      'Sürtünücü',
                affricate:      'Afrike',
                approximant:    'Daralmalı',
                'lateral-approximant': 'Yandaralmalı',
            },
            voicing: {
                voiced:     'Ötümlü',
                voiceless:  'Ötümsüz',
            },
            variant: {
                postdorsal:    'Artdamaksıl',
                predorsal:     'Öndamaksıl',
                fricative:     'Sürtünücü',
                approximant:   'Daralmalı',
                voiced:        'Ötümlü',
                devoiced:      'Ötümsüz',
                bilabial:      'Çiftdudak',
                labiodental:   'Dudakdiş',
                alveolar:      'Dişyuvasıl',
                trill:         'Çokvuruşlu',
                'tap-or-flap': 'Tekvuruşlu'
            },
        },

        vowel: {
            backness: {
                front:   'Ön',
                central: 'Orta',
                back:    'Arka',
            },
            height: {
                close:        'Kapalı',
                'near-close': 'near-close',
                'close-mid':  'Yarı-kapalı',
                mid:          'Orta',
                'open-mid':   'Yarı-açık',
                'near-open':  'near-open',
                open:         'Açık',
            },
            roundedness: {
                unrounded: 'Düz',
                rounded:   'Yuvarlak'
            },
            variant: {
                postdorsal: 'Arkadil',
                predorsal: 'Öndil',
                close: 'Kapalı',
                open: 'Açık',
                'near-open': 'Yarı-açık',
            },
        },

        alert: {
            answerCheckPrevention: {
                phonemicVowel: 'Her özellik için bir seçim yapmalısın.',
                phoneticVowel: 'Değişke özelliği için bir seçim yapmalısın.',
                phonemicConsonant: 'Her özellik için bir seçim yapmalısın.',
                phoneticConsonant: 'Değişke özelliği için bir seçim yapmalısın.',
            },
        },


        // Consonant voicing translations
        voiced:     'Ötümlü',
        voiceless:  'Ötümsüz',

        // Vowel variant feature translations
        predorsal: 'Ön dil',
        postdorsal: 'Arka dil',
        open: 'Açık',
        'near-open': 'Yarı-açık',
        close: 'Kapalı',

        analyticsIncorrects: {
            vowel: {
                // Vowel backness features.
                front:   'Ön',
                central: 'Orta',
                back:    'Arka',

                // Vowel height features.
                close:        'Kapalı',
                'near-close': 'near-close',
                'close-mid':  'Yarı-kapalı',
                mid:          'Orta',
                'open-mid':   'Yarı-açık',
                'near-open':  'near-open',
                open:         'Açık',

                // Vowel roundedness features.
                unrounded: 'Düz',
                rounded:   'Yuvarlak',

                // Vowel variant features.
                postdorsal: 'Arkadil',
                predorsal: 'Öndil',
                close: 'Kapalı',
                open: 'Açık',
                'near-open': 'Yarı-açık',
            },

            consonant: {
                // Consonant place features.
                bilabial:     'Çiftdudak',
                labiodental:  'Dudakdiş',
                alveolar:     'Dişyuvasıl',
                postalveolar: 'Artdişyuvasıl',
                palatal:      'Öndamaksıl',
                velar:        'Artdamaksıl',
                glottal:      'Gırtlaksıl',

                // Consonant manner features.
                plosive:        'Patlamalı',
                nasal:          'Genizsil',
                'tap-or-flap':  'Çarpmalı',
                fricative:      'Sürtünücü',
                affricate:      'Afrike',
                approximant:    'Daralmalı',
                'lateral-approximant': 'Yandaralmalı',

                // Consonant voicing features.
                voiced:     'Ötümlü',
                voiceless:  'Ötümsüz',

                // Consonant variant features.
                postdorsal:    'Artdamaksıl',
                predorsal:     'Öndamaksıl',
                fricative:     'Sürtünücü',
                approximant:   'Daralmalı',
                voiced:        'Ötümlü',
                devoiced:      'Ötümsüz',
                bilabial:      'Çiftdudak',
                labiodental:   'Dudakdiş',
                alveolar:      'Dişyuvasıl',
                trill:         'Çokvuruşlu',
                'tap-or-flap': 'Tekvuruşlu',
            },

            types: {
                phonemicVowel: 'ünlü özellikleri',
                phonemicConsonant: 'ünsüz özellikleri',
                phoneticVowel: 'ünlü değişkeleri',
                phoneticConsonant: 'ünsüz değişkeleri',
            },
        },

        // Practice mode translations
        'lorem_mode':       'Lorem Mode',
        'phonemic-vowel':   'Ünlü Değişkeleri',
        'phonemic-consonant': 'Ünsüz Özellikleri',
        'phonetic-vowel': 'Ünlü Değişkeleri',
        'phonetic-consonant': 'Ünsüz Değişkeleri',
        'phonetic-transcription': 'Ünsüz Transkripsiyonu',

        // Challenge status codes
        'WAIT-ANSWER': 'İSTEK YOLLANDI',
        'REJECTED': 'REDDETTİ',
        'WAIT-PRACTICE': 'PRATİKTE',
        'LEFT-PRACTICE': 'KAÇTI',
        'DONE-PRACTICE': 'PRATİK TAMAM',

        // Challenge modes
        challenge: {
            'phonemic-vowel': 'ÜNLÜ ÖZELLİKLERİ',
            'phonemic-consonant': 'ÜNSÜZ ÖZELLİKLERİ',
            'phonetic-vowel': 'ÜNLÜ DEĞİŞKELERİ',
            'phonetic-consonant': 'ÜNSÜZ DEĞİŞKELERİ',
            status: {
                'wait-answer':   'BEKLENİYOR',
                'rejected':      'REDDETTİ',
                'cancelled':     'İPTAL',
                'wait-practice': 'PRATİKTE',
                'left-practice': 'KAÇTI',
                'done-practice': 'TAMAMLADI',
            },
            generalStatus: {
                'CANCELLED': 'İPTAL EDİLDİ',
                'ONGOING':   'DEVAM EDİYOR',
            },
            results: {
                draw:   'BERABERE',
                winner: 'KAZANDI',
                loser:  'KAYBETTİ',
            }
        },

        // Challenge winning results
        draw: 'EŞİT',
        winner: 'GALİP',
        loser: 'MAĞLUP',

        // Error translations.
        error: {
            "default": "Bir şeyler ters gitti.",
            "fetch": "Sunucuda bir şeyler ters gitti.",
            "login": "Önce giriş yapmalısın.",
            
            api: {
                initializePractice: {
                    'INITIALIZE_PRACTICE_CONTROLLER/INDEX::INV_USER_SESSION': 'Pratik yapabilmek için giriş yapmalısın.',
                    'aaa': 'AAA AAA',
                },

                checkAnswer: {
                    'CHECK_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION': 'Oturumun beklenmedik bir şekilde sonlandı, tekrar giriş yap.',
                    'aaa': 'AAA AAA',
                },

                skipAnswer: {
                    'SKIP_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION': 'Oturumun beklenmedik bir şekilde sonlandı, tekrar giriş yap.',
                    'aaa': 'AAA AAA',
                },

                nextQuestion: {
                    'NEXT_QUESTION_CONTROLLER/INDEX::INV_USER_SESSION': 'Oturumun beklenmedik bir şekilde sonlandı, tekrar giriş yap.',
                    'aaa': 'AAA AAA',
                },

                challengeInitialize: {
                    'CHALLENGE_INITIALIZE_MODEL/INITIALIZE::INV_USER_SESSION': 'Meydan okumak için giriş yapmalısın.',
                    'CHALLENGE_INITIALIZE_MODEL/INITIALIZE::ONGOING_CHALLENGE_ALREADY_EXISTS': 'Bu kullanıcıyla devam eden bir meydan okuman var!'
                },

                challengeAccept: {
                    'CHALLENGE_ACCEPT_MODEL/ACCEPT::INV_USER_SESSION': 'Meydan okumayı kabul edebilmek için giriş yapmalısın.',
                },

                challengeReject: {
                    'CHALLENGE_REJECT_MODEL/REJECT::INV_USER_SESSION': 'Meydan okumayı reddedebilmek için giriş yapmalısın.',
                    'CHALLENGE_REJECT_MODEL/REJECT::CHALLENGE_NOT_EXISTS': 'Meydan okuma iptal edilmiş ya da silinmiş.',
                },

                challengeCheckAnswer: {
                    'CHALLENGE_CHECK_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION': 'Cevap verebilmek için giriş yapmalısın.',
                },

                challengeSkipAnswer: {
                    'CHALLENGE_SKIP_ANSWER_CONTROLLER/INDEX::INV_USER_SESSION': 'Geçebilmek için giriş yapmalısın.',
                },

                challengeNextQuestion: {
                    'CHALLENGE_NEXT_QUESTION_MODEL/NEXT::INV_USER_SESSION': 'Sonraki soru için giriş yapmalısın.',
                },

                challengeUsersActive: {
                    "CHALLENGE_USERS_ACTIVE_MODEL/USERS_ACTIVE::INV_USER_SESSION": 'Kullanıcı seçmek için giriş yapmalısın.',
                },

                challengeUserSearch: {
                    'CHALLENGE_USER_SEARCH_MODEL/USER_SEARCH::INV_USER_SESSION':        'Kullanıcı aramak için giriş yapmalısın.',
                    'CHALLENGE_USER_SEARCH_MODEL/USER_SEARCH::INV_USER_SEARCH_OPTIONS': 'Geçersiz karakterler girdin.',
                },

                challengeListAll: {
                    'CHALLENGE_LIST_ALL_MODEL/LIST_ALL::INV_USER_SESSION': 'Meydan okumaları görebilmek için giriş yapmalısın.',
                },

                challengeRequestAll: {
                    'CHALLENGE_REQUEST_ALL_MODEL/REQUEST_ALL::INV_USER_SESSION': 'İstekleri görebilmek için giriş yapmalısın.',
                },

                challengeRecent: {
                    'CHALLENGE_RECENT_MODEL/RECENT::INV_USER_SESSION': 'Son karşılaşmaları görebilmek için giriş yapmalısın.',
                },

                challengeLeaderboard: {
                    'CHALLENGE_LEADERBOARD_MODEL/LEADERBOARD::INV_USER_SESSION': 'En iyileri görebilmek için giriş yapmalsıın.',
                },

                challengeResolve: {
                    'CHALLENGE_RESOLVE_MODEL/RESOLVE::INV_USER_SESSION': 'Karşılaşma sonucunu görebilmek için giriş yapmalısın.',
                },

                challengeLeave: {
                    'CHALLENGE_LEAVE_MODEL/LEAVE::INV_USER_SESSION': 'Oturumun beklenmedik şekilde sonlandı.',
                },
            },
        },
    },
};

export default createI18n({
    locale: 'tr',
    messages: messages
});